import React from 'react';
import { Building2, RotateCcw } from 'lucide-react';

/**
 * Picks which working company the module toggles below apply to.
 * "Client default" edits the client row (inherited by every company without
 * its own switches); a company edits its own explicit switches.
 */
const WorkingCompanySelector = ({
  theme,
  companies,
  selected,
  selectedEntry,
  loading,
  saving,
  onSelect,
  onReset,
}) => {
  const light = theme === 'light';
  return (
    <div style={{
      borderRadius: '12px',
      border: light ? '1.5px solid rgba(46,124,186,0.25)' : '1px solid rgba(46,124,186,0.25)',
      background: light ? 'rgba(46,124,186,0.06)' : 'rgba(46,124,186,0.1)',
      padding: '12px 14px',
      marginBottom: '16px',
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      gap: '10px',
    }}>
      <Building2 size={16} color="#2e7cba" />
      <span style={{ fontSize: '12.5px', fontWeight: 700, color: light ? '#0f172a' : '#ffffff' }}>
        Modules for
      </span>
      <select
        value={selected}
        disabled={loading || saving}
        onChange={(e) => onSelect(e.target.value)}
        style={{
          flex: '1 1 220px',
          minWidth: '220px',
          padding: '8px 10px',
          borderRadius: '8px',
          fontSize: '13px',
          border: light ? '1px solid #cbd5e1' : '1px solid rgba(255,255,255,0.15)',
          background: light ? '#ffffff' : '#0f172a',
          color: light ? '#0f172a' : '#ffffff',
        }}
      >
        <option value="">Client default (all working companies without their own switches)</option>
        {companies.map((c) => (
          <option key={c.workingCompany} value={c.workingCompany}>
            {c.workingCompany}{c.hasOverrides ? ' — custom' : ' — follows client default'}
          </option>
        ))}
      </select>
      {selected && selectedEntry?.hasOverrides && (
        <button
          type="button"
          onClick={onReset}
          disabled={saving}
          title="Remove this company's own switches so it follows the client default again"
          style={{
            display: 'flex', alignItems: 'center', gap: '6px',
            padding: '8px 12px', fontSize: '12.5px', fontWeight: 600,
            borderRadius: '8px', cursor: 'pointer',
            border: light ? '1.5px solid #e2e8f0' : '1.5px solid rgba(255,255,255,0.1)',
            background: light ? '#ffffff' : 'rgba(255,255,255,0.05)',
            color: light ? '#374151' : 'rgba(255,255,255,0.8)',
          }}
        >
          <RotateCcw size={13} />
          Reset to client default
        </button>
      )}
      <span style={{
        flexBasis: '100%',
        fontSize: '11.5px',
        color: light ? '#64748b' : 'rgba(255,255,255,0.55)',
      }}>
        {selected
          ? `Saving writes ${selected}'s own switches; they win over the client default for employees of that working company.`
          : loading
            ? 'Loading working companies…'
            : `${companies.length} working compan${companies.length === 1 ? 'y' : 'ies'} in this client. Subscription, status and code policy are always client-level.`}
      </span>
    </div>
  );
};

export default WorkingCompanySelector;
